import { render, staticRenderFns } from "./ProductCreateEdit.vue?vue&type=template&id=a0d59620&scoped=true&"
import script from "./ProductCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d59620",
  null
  
)

export default component.exports